import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import anchorIcon from "@phosphor-icons/core/regular/anchor.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const lessonHook: Tool = {
    urlSlug: "lesson-hook",
    configName: "teacher-tool-lesson-hook",
    title: () => t`Lesson hook`,
    description: () => t`Plan compelling lesson starters to engage students`,
    categories: [ToolCategories.Plan, ToolCategories.Create],
    icon: anchorIcon,
    color: color.fadedPurple24,
    layout: Layout.Coeditor,
    activitySlug: "activity-create-a-lesson-hook",
    reportingLabelId: "create-lesson-hook",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            description: () => "",
            inputKind: "SINGLE_SELECT",
            label: () => t`Grade level`,
            required: true,
            selectOptions: [
                {
                    label: () => t`1st grade`,
                    value: "1st grade",
                },
                {
                    label: () => t`2nd grade`,
                    value: "2nd grade",
                },
                {
                    label: () => t`3rd grade`,
                    value: "3rd grade",
                },
                {
                    label: () => t`4th grade`,
                    value: "4th grade",
                },
                {
                    label: () => t`5th grade`,
                    value: "5th grade",
                },
                {
                    label: () => t`6th grade`,
                    value: "6th grade",
                },
                {
                    label: () => t`7th grade`,
                    value: "7th grade",
                },
                {
                    label: () => t`8th grade`,
                    value: "8th grade",
                },
                {
                    label: () => t`9th grade`,
                    value: "9th grade",
                },
                {
                    label: () => t`10th grade`,
                    value: "10th grade",
                },
                {
                    label: () => t`11th grade`,
                    value: "11th grade",
                },
                {
                    label: () => t`12th grade`,
                    value: "12th grade",
                },
                {
                    label: () => t`College`,
                    value: "College",
                },
            ],
            variableName: "gradeLevel",
        },
        {
            description: () => t`e.g. the Solar System`,
            inputKind: "TEXT_BOX",
            label: () => t`Lesson topic`,
            required: true,
            variableName: "topic",
        },
        {
            description: () =>
                t`e.g. learning about how planets in the Solar System are affected by gravity`,
            inputKind: "TEXT_AREA",
            label: () => t`Lesson context`,
            variableName: "lessonContext",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
